module.exports = __webpack_public_path__ + "img/notes.15bed511.svg";